<template>
    <nav v-if="show" class="ticker-bar" :class="`ticker-bar--${backgroundColor}`">
        <ul class="ticker-bar__ticks">
            <template v-for="(tick, index) in ticks">
                <li :key="index" class="ticker-bar__tick" :class="`ticker-bar__tick--${textColor}`">
                    <span class="ticker-bar__check">✓</span>
                    {{ tick.text }}
                </li>
            </template>
            <template v-for="(tick, index) in ticks">
                <li
                    :key="index + 'm'"
                    class="ticker-bar__tick ticker-bar__tick--hide-on-desktop"
                    :class="`ticker-bar__tick--${textColor}`"
                >
                    <span class="ticker-bar__check">✓</span>
                    {{ tick.text }}
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
import './ticker-bar.scss';

export default {
    name: 'TickerBar',
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'grey', 'white', 'black', 'none', 'orange'],
            },
            textColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'grey', 'white', 'black', 'none', 'grey-two'],
            },
            ticks: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        text: {
                            widget: 'text',
                        },
                    },
                },
            },
        },
    },
    props: {
        backgroundColor: {
            type: String,
            default: 'orange',
        },
        textColor: {
            type: String,
            default: 'white',
        },
        ticks: {
            type: Array,
            default: () => [],
        },
        showOnMobile: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        windowWidth: window.innerWidth,
    }),
    computed: {
        show() {
            return this.showOnMobile ? true : this.windowWidth > 768;
        },
    },
    created() {
        window.addEventListener('resize', this.handleResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    },
};
</script>
